import React from 'react';
import PropTypes from "prop-types";
import {Checkbox} from "semantic-ui-react";
import LastUpdated from "../../../common/partials/LastUpdated";
import {connect} from "react-redux";
import {PricingTableSortFields} from "../constants/PricingTablesActionConstants";
import MARVEL from "../../../common/utils/MarvelUrls";
import {Link} from "react-router-dom";

export class PricingTablesListRowV2 extends React.Component {

    static propTypes = {
        pricingName: PropTypes.string,
        countryCount: PropTypes.number,
        tenantCount: PropTypes.number,
        basePrice: PropTypes.number,
        volumeAggregationType: PropTypes.string,
        lastUpdated: PropTypes.string,
    }

    get pricingTableCheckbox() {
        return (
            <td className="low-width">
                <Checkbox disabled />
            </td>
        )
    }

    get name() {
        const { pricingName, pricingID, pricingTableSortKey } = this.props;
        let classnames = "";
        if (pricingTableSortKey === PricingTableSortFields.NAME) {
            classnames += "current-sort";
        }
        return (
            <td className={classnames}>
                <Link to={{pathname: MARVEL.BILLING.pricing_tables_v2 + pricingID}} key={pricingID}>
                    {pricingName}
                </Link>
            </td>

        )
    }

    get lastUpdated() {
        const { lastUpdated, pricingTableSortKey } = this.props;
        let lastUpdatedElement;
        let classnames = "";
        if (pricingTableSortKey === PricingTableSortFields.LAST_UPDATED) {
            classnames += "current-sort";
        }
        if (lastUpdated === null) {
            lastUpdatedElement = '';
        } else {
            lastUpdatedElement = <LastUpdated lastUpdated={lastUpdated} type="medium" />;
        }
        return (
            <td className={classnames}>
                {lastUpdatedElement}
            </td>
        )
    }

    render() {

        return (
            <tr>
                {this.pricingTableCheckbox}
                {this.name}
                <td>{"USD "}{this.props.basePrice}</td>
                <td>{this.props.countryCount}</td>
                <td>{this.props.tenantCount}</td>
                <td>{this.props.volumeAggregationType}</td>
                {this.lastUpdated}
            </tr>
        )
    }
}

const mapStateToProps = (state) => ({
    pricingTableSortKey: state.billing.pricing.pricingTableSortKey,
});

const mapDispatchToProps = dispatch => ({
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PricingTablesListRowV2)
